export default __webpack_public_path__ + "static/media/forestly-expl-base_DE.2d61ee27.png";